import { useEffect, useState } from 'react'

const resultKeys = [
  { name: 'post_title', term_id: 'ID' },
  { name: 'name', term_id: 'term_id' }, // Default
  { name: 'title', term_id: 'id' }
]

const resultKeysByRoute = {
  ROUTE_ACTIVITIES_MEDITATION_ALL: resultKeys[2],
  ROUTE_ACTIVITIES_COPINGSKILLS_ALL: resultKeys[2],
  ROUTE_ACTIVITIES_AFFIRMATIONS_ALL: resultKeys[1],
  ROUTE_ACTIVITIES_JOURNALING_ALL: resultKeys[1],
  ROUTE_ACTIVITIES_JOURNALING_DAILY: resultKeys[1],
  ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL: resultKeys[1],
  ROUTE_ACTIVITIES_BREATHING_ALL: resultKeys[2],
  ROUTE_ACTIVITIES_COMPLIMENTS_ALL: resultKeys[1],
  ROUTE_ACTIVITIES_DATE_IDEAS: resultKeys[1]
}

const useFetchAllList = (fetchFunction, cache, cacheKey) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [data, setData] = useState({})

  const getParsedResult = result => {
    // Get the keys for the result, or use the default
    const { name, term_id } = resultKeysByRoute[cacheKey] || resultKeys[1]

    return result.map(item => ({
      ...item,
      name: item[name],
      term_id: item[term_id]
    }))
  }

  useEffect(() => {
    let result = cache?.getCache(cacheKey)

    if (result) {
      setData(getParsedResult(result))
      setIsLoaded(true)
    }

    if (!result) {
      ;(async () => {
        let result = await fetchFunction()
        let parsedResult = getParsedResult(result)

        setData(parsedResult)
        setIsLoaded(true)
        cache?.cache(cacheKey, result)
      })()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchFunction, cache, cacheKey])

  return {
    data,
    isLoaded
  }
}

export default useFetchAllList
